(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Dummy", [], factory);
	else if(typeof exports === 'object')
		exports["Dummy"] = factory();
	else
		root["Dummy"] = factory();
})(this, function() {
return 